module.exports = __webpack_public_path__ + "account/assets/no-pic.6114a680.svg";